import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from '@components/common/Header';
import { useAuth } from '@services/authentication/auth.context';
import useGetMenuLayout from '@components/ui/layout/hooks/useGetMenuLayout';

const AppShellLayout: React.FC = () => {
 
  const { user } = useAuth();

  const headerItems = useGetMenuLayout();

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header items={headerItems} userProfile={user} />
      <Box
        sx={{
          flex: 1,
          pt: 8, // Padding-top to account for fixed header
          px: { xs: 2, md: 3 },
          py: { xs: 2, md: 3 },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AppShellLayout;
